export const riyadhDistricts = [
  'العليا',
  'الملز',
  'المروج',
  'الورود',
  'الغدير',
  'الياسمين',
  'الربيع',
  'حطين',
  'النرجس',
  'القيروان',
  'الصحافة',
  'المرسلات',
  'الزهراء',
  'الشفا',
  'السلام',
  'المنار',
  'قرطبة',
  'الرمال',
  'الجزيرة',
  'السليمانية',
];